var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"love-value-mall-poster",attrs:{"src":require("../../assets/chaofandashi/love_value_mall_poster.jpg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }